<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const props = defineProps({
  message: String,
  formMessage: Object,
  full: Boolean
})
const flash = computed(() => usePage().props.flash)

const message = computed(() => {
  if (props.message) return props.message
  if (flash.value?.alert) return flash.value.alert
  if (props.formMessage) return Object.values(props.formMessage).join(' ')

  return undefined
})
</script>

<template>
  <template v-if="full">
    <div v-if="message" class="alert alert-danger alert-full" role="alert">
      <div class="mx-auto max-w-screen-xl">
        <span>{{ message }}</span>
      </div>
    </div>
  </template>
  <template v-else>
    <div v-if="message" class="alert alert-danger" role="alert">
      <span>{{ message }}</span>
    </div>
  </template>
</template>
